import { ConfirmationDialogConfig } from "src/app/services/confirmation-dialog.service";
import { DeleteAction } from "./delete-action";

export class DeleteAssociationAction extends DeleteAction {
  /**
   * Default config for remove association confirmation dialog.
   */
  override confirmDialogConfig: ConfirmationDialogConfig = {
    title: "Disassocia",
    message: "Sicuro di voler proseguire?",
    confirmButtonLabel: "Conferma",
    cancelButtonLabel: "Annulla",
    dialogSize: "sm",
  };

  override execute(val: any, row: any): void {
    const deleteAssociation = () => {
      const entityId = this.component.getServiceUrl().getUrlId(this.component.settings.page);
      const resourceId = val.id;
      return entityId + "/" + resourceId;
    };

    super.execute(val, row, deleteAssociation);
  }
}
